import React from 'react';
import styles from '../../Popover.scss.js';

function Section({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Section
  }, children);
}

export { Section };
